<template>
  <div>
    <vue-tree-navigation
      v-if="!asDialog"
      :items="items"
      class="treeNavClass"
    ></vue-tree-navigation>
    <!-- <v-dialog v-else v-model="dialog" max-width="95%">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="#ffc46c"
          v-bind="attrs"
          v-on="on"
          class="ma-2 buttonWidth"
          depressed
        >
          <v-icon class="mx-2">mdi-file-tree-outline</v-icon>
          {{ dialogTitle }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <vue-tree-navigation
            :items="items"
            class="treeNavClass"
          ></vue-tree-navigation>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import Vue from "vue";
import VueTreeNavigation from "vue-tree-navigation";
Vue.use(VueTreeNavigation);

export default {
  name: "TreeNavigation",
  props: {
    items: null,
    asDialog: null,
    dialogTitle: {
      type: String,
      default: "Choose Article",
    },
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.treeNavClass >>> .NavigationItem--active {
  background-color: #e2f3ff;
  padding: 3px 30px 3px 5px;
  border-top-right-radius: 18px;
  border-bottom-right-radius: 15px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.treeNavClass >>> .NavigationItem {
  cursor: pointer;
  padding-left: 5px;
}
.buttonWidth {
  width: 98%;
}
</style>
